import React, { Component } from 'react';
import Highcharts from 'highcharts'

import HighchartsReact from 'highcharts-react-official';

const colors = [
    // "#ef9a9a",
    // "#F48FB1",
    // "#CE93D8",
    // "#B39DDB",
    // "#9FA8DA",
    // "#90CAF9",
    // "#81D4FA",
    // "#80DEEA",
    "#80CBC4",
    // "#A5D6A7",
    "#C5E1A5",
    // "#E6EE9C",
    "#FFF59D",
    // "#FFE082",
    "#FFCC80",
    // "#FFAB91",

    "#e57373",
    // "#F06292",
    "#BA68C8",
    // "#9575CD",
    "#7986CB",
    // "#64B5F6",
    "#4FC3F7",
    // "#4DD0E1",
    "#4DB6AC",
    // "#81C784",
    "#AED581",
    // "#DCE775",
    "#FFF176",
    // "#FFD54F",
    "#FFB74D",
    // "#FF8A65",

    "#ef5350",
    // "#EC407A",
    "#AB47BC",
    // "#7E57C2",
    "#5C6BC0",
    // "#42A5F5",
    "#29B6F6",
    // "#26C6DA",
    "#26A69A",
    // "#66BB6A",
    "#9CCC65",
    // "#D4E157",
    "#FFEE58",
    // "#FFCA28",
    "#FFA726",
    // "#FF7043",

    "#f44336",
    // "#E91E63",
    "#9C27B0",
    // "#673AB7",
    "#3F51B5",
    // "#2196F3",
    "#03A9F4",
    // "#00BCD4",
    "#009688",
    // "#4CAF50",
    "#8BC34A",
    // "#CDDC39",
    "#FFEB3B",
    // "#FFC107",
    "#FF9800",
    // "#FF5722",

    "#e53935",
    // "#D81B60",
    "#8E24AA",
    // "#5E35B1",
    "#3949AB",
    // "#1E88E5",
    "#039BE5",
    // "#00ACC1",
    "#00897B",
    // "#43A047",
    "#7CB342",
    // "#C0CA33",
    "#FDD835",
    // "#FFB300",
    "#FB8C00",
    // "#F4511E",

    "#d32f2f",
    // "#C2185B",
    "#7B1FA2",
    // "#512DA8",
    "#303F9F",
    // "#1976D2",
    "#0288D1",
    // "#0097A7",
    "#00796B",
    // "#388E3C",
    "#689F38",
    // "#AFB42B",
    "#FBC02D",
    // "#FFA000",
    "#F57C00",
    // "#E64A19",

    "#c62828",
    // "#AD1457",
    "#6A1B9A",
    // "#4527A0",
    "#283593",
    // "#1565C0",
    "#0277BD",
    // "#00838F",
    "#00695C",
    // "#2E7D32",
    "#558B2F",
    // "#9E9D24",
    "#F9A825",
    // "#FF8F00",
    "#EF6C00",
    // "#D84315",

    "#b71c1c",
    // "#880E4F",
    "#4A148C",
    // "#311B92",
    "#1A237E",
    // "#0D47A1",
    "#01579B",
    // "#006064",
    "#004D40",
    // "#1B5E20",
    "#33691E",
    // "#827717",
    "#F57F17",
    // "#FF6F00",
    "#E65100",
    // "#BF360C",

]
class HighChart extends Component {

    render() {
        const {
            type,
            title,
            titleY,
            categories, // column names
            series, // series: [{
                //     name: 'John', // type abo
                //     data: [5, 3, 4, 7, 2] // nb / week
                // }, {
                //     name: 'Jane',
                //     data: [2, 2, 3, 2, 1]
                // }, {
                //     name: 'Joe',
                //     data: [3, 4, 4, 2, 5]
                // }]
            
        } = this.props;

        let chartOptions = {
            colors: colors,
            chart: {
                type: type
            },
            title: {
                text: title
            },
            xAxis: {
                categories: categories
            },
            yAxis: {
                min: 0,
                title: {
                    text: titleY
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: ( // theme
                            Highcharts.defaultOptions.title.style &&
                            Highcharts.defaultOptions.title.style.color
                        ) || 'gray'
                    }
                }
            },
            series: series,
            credits: {
                enabled: false
            },

            legend: {
                // enabled: false,
                align: 'center',
                // x: -30,
                verticalAlign: 'bottom',
                // y: 25,
                floating: false,
                backgroundColor:
                    Highcharts.defaultOptions.legend.backgroundColor || 'white',
                borderColor: '#CCC',
                borderWidth: 1,
                shadow: false
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            
        }
        let StyleMenu = {
            width: "90%",
            height: "50% ",
            margin: "0 auto",
            position: "relative"
        };
        return (
            <div style={this.props.StyleMenu || StyleMenu}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={chartOptions}
                />
            </div>
        );
    }
}

export default HighChart;